import Image from 'next/image'

export default function Author({ name, date, avatar }: { name: string; date: string; avatar: string }) {
  return (
    <div className="flex items-center gap-3 pt-2">
      <div className="relative h-9 w-9 overflow-hidden rounded-full">
        <Image src={avatar} alt={name} className="object-cover" width={36} height={36} />
      </div>
      <div className="flex flex-col font-[330]">
        <span className="text-sm text-secondary">{name}</span>
        <time className="text-sm text-secondary">{date}</time>
      </div>
    </div>
  )
}
